<template>
  <button
    :disabled="disabled"
    :class="dynamicStyles"
    class='px-4 py-2 mt-2 font-semibold border rounded'
    @click="$emit('button-click')"
  >
    {{text}}
  </button>

</template>

<script>
export default {
  name: 'generalButton',
  props: {
    text: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    color: {
      type: String,
      required: true,
      validator: (color) => ['blue', 'green', 'red'].includes(color),
    },
    error: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    dynamicStyles() {
      return [
        this.disabled ? 'text-gray-100 bg-gray-700 cursor-wait' : `hover:bg-${this.color}-500 text-${this.color}-700 hover:text-white bg-transparent`,
        this.error ? 'border border-red-500' : `border-${this.color}-500 hover:border-transparent`,
      ];
    },
  },
};
</script>
